import VectorSource from "ol/source/Vector";
import {GeoJSON} from "ol/format";
import VectorLayer from "ol/layer/Vector";
import {shapeStyleFunction} from "@/lib/client";
import {Coordinate} from "ol/coordinate";

export function readFeatures(features: any[]) {

  return features ? features.map((f: any) => FeatureGeoJSON(f.geometry.type, f.geometry.Point ?? f.coordinates, f.propertyIsEnumerable())) : []
}

export function FeatureGeoJSON(type: 'Point'|string, center: [number, number]|Coordinate, properties: any){
  return {
    type: 'Feature',
    geometry: {
      type:  type,
      coordinates: center
    },
    properties: properties
  }
}

export function FeatureGeoJSONLayer(featuresGeoJSON: any[]) {


  return new VectorLayer({
    source: new VectorSource({
      features: new GeoJSON().readFeatures({
        "type": "FeatureCollection",
        "features": featuresGeoJSON
      }, {
        dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'
      }),
    }),
    style: shapeStyleFunction,
    visible: true
  })
}